<template>
    <q-card class="bg-grey-1">
        <q-card-main class="relative-position" :class="webcastBlocked ? 'no-pointer-events' : 'cursor-pointer'">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm">
                <div class="col-3" :class="webcastBlocked ? 'disable-image' : ''"  @click="goToWebcast()">
                    <img class="training-thumb" :src="webcast.image_small" v-if="webcast.image_small">
                    <img class="training-thumb" :src="getPlaceholder" v-if="!webcast.image_small">
                </div>

                <div class="col-9" @click="goToWebcast()">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium" :class="webcastBlocked ? 'text-faded' : 'text-primary'">
                            {{ webcast.title }}
                        </div>

                        <div class="col-12 q-subheading text-weight-regular" :class="webcastBlocked ? 'text-faded' : 'text-primary'">
                            {{ $t('transmission_date') }} {{ fDate(webcast.transmission_date) }} {{ `(${webcast.timezone})` }}
                        </div>

                        <div class="col-12 q-mt-md">
                            <div class="row">
                                <div class="col-6">
                                    <p class="caption" v-if="webcast.areas.length > 0">
                                        {{ $t('areas') }}
                                    </p>
                                    <p v-if="webcast.areas.length > 0" class="tooltip q-mb-sm">
                                        <span v-for="(area, index) in webcast.areas" :key="index">
                                            {{ getArea(area) }}<span v-if="(webcast.areas.length - 1) > index">, </span>
                                        </span>
                                    </p>

                                    <p class="caption" v-if="webcast.user_groups.length > 0">
                                        {{ $t('groups') }}
                                    </p>
                                    <p v-if="webcast.user_groups.length > 0" class="tooltip q-mb-sm">
                                        <span v-for="(group, index) in webcast.user_groups" :key="index">
                                            {{ getGroup(group) }}<span v-if="(webcast.user_groups.length - 1) > index">, </span>
                                        </span>
                                    </p>
                                </div>

                                <div class="col-6">
                                    <p class="caption" v-if="webcast.tags.length > 0">
                                        {{ $t('tags') }}
                                    </p>
                                    <p class="tooltip q-mb-sm">
                                        <span v-for="(tag, index) in webcast.tags" :key="index">
                                            {{ getTag(tag) }}<span v-if="(webcast.tags.length - 1) > index">, </span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </q-card-main>

        <q-card-separator v-if="showSubscribeButton" />

        <q-card-actions v-if="showSubscribeButton">
            <q-btn :color="getSubscribeButtonColor" class="full-width" :label="$t(getSubscribeButtonLabel)" :icon="getSubscribeButtonIcon" @click="subscribeWebcast()" />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'
import { date } from 'quasar'
const { getDateDiff, formatDate } = date

export default {
    props: ['webcast'],

    data() {
        return {
            selected_client_params: [],
            sections: [],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.webcast_placeholder) return ''
            else return this.selected_client_params.webcast_placeholder
        },

        webcastBlocked() {
            let diff = date.getDateDiff(this.webcast.transmission_date, new Date(), 'minutes')

            if (this.webcast.webcast_user_subscribed && diff <= 15) return false
            else return true
        },

        showSubscribeButton() {
            // let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            // if (obj) {
            //     if (!obj.has_webcast_subscription) return false
            // }

            // let diff = date.getDateDiff(this.webcast.transmission_date, new Date(), 'minutes')

            // if (diff <= -15) return false
            // else return true
            return true
        },

        getSubscribeButtonLabel() {
            if (!this.webcast.webcast_user_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getSubscribeButtonIcon() {
            if (!this.webcast.webcast_user_subscribed) return 'far fa-sign-in'
            else return 'far fa-sign-out'
        },

        getSubscribeButtonColor() {
            if (!this.webcast.webcast_user_subscribed) return 'primary'
            else return 'tertiary'
        }
    },

    methods: {
        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        goToWebcast() {
            if (!this.webcastBlocked) this.$router.push({ name: 'webcast', params: { id: this.webcast.id } })
        },

        subscribeWebcast() {
            this.$emit('subscribe_webcast')
        },

        fDate(d) {
            let format = ''

            switch(this.id_user_language_selected) {
                case 1:
                case 3: format = 'DD/MM/YYYY HH:mm:ss'
                break
                default: format = 'MM-DD-YYYY HH:mm:ss'
                break
            }

            return date.formatDate(d, format)
        },
    },

	created() {
        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
	}
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.training-thumb
    width 90%
    height auto
    border-radius 10px

.disable-image
    & img
        opacity: 0.5
</style>
